import React from "react";
import { useUserStore } from '../stores/userStore';

export default function CardNote( { columns } ) {
    const noteText = useUserStore(state => state.noteText)
    const setNoteText = useUserStore(state => state.setNoteText)

  return (
    <li key="note" className="card-item note" style={{'--note-cols' : columns }}>
      <textarea
        className="card card-note"
        onChange={(e) => {
          setNoteText(e.target.value);
        }}
        value={noteText}
      ></textarea>
    </li>
  );
}
